import { MessageCircle } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { FAQAccordion } from "@/components/FAQAccordion";
import { CTASection } from "@/components/CTASection";
import { ASSETS, FAQ_CATEGORIES, waLink, WA_MESSAGES } from "@/lib/site";

export default function PerguntasFrequentes() {
  return (
    <>
      <PageHero
        overline="Ajuda"
        title="Perguntas frequentes"
        subtitle="Reunimos as dúvidas mais comuns para ajudar você a decidir com tranquilidade. Não encontrou o que procurava? Fale com a Miríade."
        seoTitle="Perguntas Frequentes | Miríade Turismo"
        seoDescription="Tire suas dúvidas sobre compra de viagens, atendimento, pagamento, documentação, seguro viagem e mais com a Miríade Turismo."
      />

      <section className="px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <FAQAccordion categories={FAQ_CATEGORIES} />
          </div>
          <aside className="lg:col-span-1">
            <div className="sticky top-28 rounded-3xl border border-brand-light bg-brand-light/60 p-7 text-center">
              <img src={ASSETS.mascot} alt="Mascote da Miríade Turismo" className="mx-auto h-36 w-36 object-contain drop-shadow-xl animate-float" />
              <h3 className="mt-4 font-heading text-xl font-semibold text-ink">Ainda com dúvidas?</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-soft">A Miríade te ajuda a encontrar o melhor caminho para sua próxima viagem.</p>
              <a
                href={waLink(WA_MESSAGES.doubts)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="faq-whatsapp-btn"
                className="mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-6 py-3.5 text-sm font-semibold text-white transition-all hover:scale-[1.03] hover:bg-[#1ebe5d]"
              >
                <MessageCircle size={18} /> Falar com a Miríade
              </a>
            </div>
          </aside>
        </div>
      </section>

      <CTASection title="Vamos planejar sua próxima viagem?" />
    </>
  );
}
